export default __webpack_public_path__ + "static/media/check-circle.0aff6656.gif";